module.exports = __webpack_public_path__ + "static/media/tc-header.fa100083.png";